export default "__VITE_ASSET__DMS4jbfw__"